import type { DealerResultType } from "../../../common-deprecated/utils/dealerConstants";
import { type TradeInAemDealerActionsType, TRADE_IN_AEM_DEALER_SET_DEALER } from "../actions/TradeInAemDealerActions";

export type TradeInAemDealerReducerType = {
    initialized: boolean;
    dealer: DealerResultType | null;
};

export const initialStateTradeInAemDealer: TradeInAemDealerReducerType = {
    initialized: false,
    dealer: null,
};

const TradeInAemDealerReducer = (
    state: TradeInAemDealerReducerType = initialStateTradeInAemDealer,
    action: TradeInAemDealerActionsType,
): TradeInAemDealerReducerType => {
    switch (action.type) {
        case TRADE_IN_AEM_DEALER_SET_DEALER: {
            const { dealer } = action;
            return { ...state, dealer, initialized: true };
        }

        default:
            return state;
    }
};

export default TradeInAemDealerReducer;
